import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiConnector } from "../apiConnector";
import { toast } from "react-toastify";
import { endpoint } from "../apis";
import Cookies from "js-cookie";

export const versionControl = createAsyncThunk(
  "versionControl/action",
  async ({ actionType, data, page = 1 }, { dispatch, rejectWithValue }) => {
    try {
      const token = Cookies.get("authToken");
      let payload;

      switch (actionType) {
        case "list":
          payload = {
            action: actionType,
            limit: 10,
            exclusive_start_key: data.lastEvaluatedKey,
          };
          break;
        case "create":
        case "update":
          payload = {
            ...data,
            action: actionType,
          };
          break;
        default:
          return rejectWithValue("Invalid action type");
      }

      const response = await apiConnector(
        "post",
        endpoint.VERSION_CONTROL,
        payload,
        { Authorization: `Bearer ${token}` }
      );

      if (response.data.Response) {
        switch (actionType) {
          case "list":
            toast.success("Version list fetched successfully!");
            return { actionType, data: response.data.Response };
          case "create":
            toast.success(`Version ${data.version} created successfully!`);
            dispatch(versionControl({ actionType: "list", data: {}, page }));
            return { actionType, data: response.data };
          case "update":
            toast.success(`Version ${data.version} updated successfully!`);
            dispatch(versionControl({ actionType: "list", data: {}, page }));
            return { actionType, data: response.data };
          default:
            return rejectWithValue("Invalid action type");
        }
      } else {
        return rejectWithValue("Unexpected response format.");
      }
    } catch (error) {
      if (error?.response?.data === "('Token has been expired',)") {
        localStorage.clear();
        window.location.href = "/";
        toast.error("Session expired. Please log in again.");
      } else {
        toast.error(error.response?.data || "API request failed.");
      }
      return rejectWithValue(error.response?.data || "API request failed.");
    }
  }
);
